<img
  #activeIndicator
  class="selected"
  alt="selected item indicator"
  src="../../../../assets/icons/product-filter-active-indicator.svg"
/>
